/* PavCon, LLC Proprietary.All rights reserved 2023 */
import { Observable, throwError } from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppSnackbarService } from '../services/app-snackbar.service';

export interface IAppResponse {
  response: any;
}
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  cachedRequests: Array<HttpRequest<any>> = [];

  constructor(private ngxService: NgxUiLoaderService, private snackBar: AppSnackbarService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((res) => {
        if (res instanceof HttpResponse) {
          this.ngxService.stopAll();
        }
        return res;
      }),
      catchError((err: HttpErrorResponse) => {
        console.log(err);
        if (err instanceof HttpErrorResponse) {
          this.ngxService.stopAll();
          console.log(err);
          console.log(err.error?.exceptionMessage);
          // this.progressBar.complete();
          // RELOGIN IF INVALID GRANT
          if (err.status === 400 && err.error?.error === 'invalid_grant') {
            // TODO: redirect to login screen & clear LS
          }
          // REFRESH TOKEN IF UNAUTHORIZED
          if (![401, 400].includes(err.status)) {
            //   this.toastr.error(err.message);

            if (
              [500, 502].includes(err.status) &&
              err.error?.exceptionMessage === 'Unauthorizad operation'
            ) {
              // TODO: redirect to main page
              this.throwError('Unauthorized', '', 8000, ['error-snackbar']);
            }
          }
          return throwError(() => err);
        }
        return throwError(() => err);
      })
    );
  }
  throwError(title, msg, duration, panelClass) {
    this.snackBar.open(title, msg, duration);
  }
}
